import { Divider } from "antd";
import React, { useContext } from "react";
import VerifyItem from "./verifyItem";
import { VerifyContext } from "../../pages/verification/verify";

const DataVerify = () => {
  const { form, curriList, lavelList } = useContext<any>(VerifyContext);
  return (
    <div>
      <div className="row text-start">
        <h4>
          รายละเอียดผลการทวนสอบฯ ประจำปีการศึกษา {`${form.year}`}
        </h4>
      </div>
      <div className="row">
        <table className="table table-hover table-responsive">
          <thead className="table-dark">
            <tr>
              <th style={{ width: "40%" }}>หลักสูตร</th>
              <th>วันที่ส่งเอกสาร</th>
              <th style={{ width: "8%" }}>จำนวนรายวิชาที่เปิดสอนทั้งหมด</th>
              <th style={{ width: "8%" }}>รายวิชาที่ทวนสอบฯ</th>
              <th >รายวิชาที่ทวนสอบฯ คิดเป็นร้อยละ</th>
              <th>Handle</th>
            </tr>
          </thead>
          <tbody>
            <Divider orientation="left">
              <h4>ระดับ {lavelList[0]}</h4>
            </Divider>

            {curriList
              .filter((x: any) => x.level === lavelList[0])
              .map((c: any) => {
                return <VerifyItem curri={c} />;
              })}

            <Divider orientation="left">
              <h4>ระดับ {lavelList[1]}</h4>
            </Divider>
            {curriList
              .filter((x: any) => x.level === lavelList[1])
              .map((c: any) => {
                return <VerifyItem curri={c} />;
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataVerify;
